import { Component, OnInit } from '@angular/core';
import { WaveService } from '../../../../../services/wave.service';

@Component({
  selector: 'app-wave-transactions',
  templateUrl: './wave-transactions.component.html',
  styleUrls: ['./wave-transactions.component.scss']
})
export class WaveTransactionsComponent implements OnInit {
  transactionDoneBywave = [];
  constructor(private waveService: WaveService) { }

  ngOnInit(): void {
    this.retrieveWaveTransactions();
  }

  // Liste des transaction effectuées avec Wave
  retrieveWaveTransactions(): void{
    this.waveService.returnWaveTransactions().subscribe(result=>{
      // console.log("Transactions effectuées par wave ..")
      // console.log(result)
    })
  }

}
